// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2562":"67393158117540e3","2888":"109e809ab724b51d","6211":"691cb9ea5be8a2d3"}[chunkId] + ".css";
};